import { useQuery } from '@tanstack/react-query';
import { Package } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function useHolidayPricelist(schoolId) {
  return useQuery([QUERY_KEYS.PRICELIST, QUERY_KEYS.holiday], () => (
    Package
      .includes([{ options: ['prices'] }])
      .where({ category: 'gift' })
      .where({ schoolId: schoolId})
      .first()
      .then((res) => res.data)
  ));
}
